<template>
  <div
    class="w-full max-w-lg bg-white p-6 rounded-[32px] shadow-[0_20px_40px_-15px_rgba(28,72,72,0.1)] border border-[#1c4848]/5 relative overflow-hidden group"
  >
    <div
      class="absolute top-0 right-0 w-32 h-32 bg-gradient-to-bl from-[#ecd79f]/20 to-transparent rounded-bl-full"
    ></div>

    <div class="flex justify-between items-end mb-6 relative z-10">
      <div>
        <p class="text-sm font-semibold text-[#1c4848]/40 uppercase tracking-widest mb-1">
          {{ t('home.nextPrayer.label') }}
        </p>
        <h3 class="text-4xl font-serif text-[#1c4848] font-semibold flex items-center gap-3">
          {{ prayerLabel(nextPrayer?.key) }}
          <iconify-icon icon="solar:moon-fog-linear" class="text-2xl text-[#ecd79f]"></iconify-icon>
        </h3>
      </div>
      <div class="text-right">
        <p
          class="text-xs font-semibold text-emerald-600 bg-emerald-50 px-2 py-1 rounded-lg inline-block mb-1"
        >
          {{ t('home.nextPrayer.statusOnTime') }}
        </p>
        <p class="text-xs font-semibold text-[#1c4848]/40 uppercase tracking-widest mb-1">
          {{ t('home.nextPrayer.startsIn') }}
        </p>
        <p class="text-2xl font-serif text-[#1c4848] font-semibold tracking-tight">
          {{ countdownText }}
        </p>
      </div>
    </div>

    <div class="relative w-full h-12 flex items-center z-10 mb-4">
      <div class="absolute w-full h-1.5 bg-[#1c4848]/5 rounded-full"></div>
      <div
        class="absolute h-1.5 bg-gradient-to-r from-[#1c4848] to-[#2d7a7a] rounded-full shadow-[0_0_10px_rgba(28,72,72,0.3)]"
        :style="{ width: `${Math.round(progressRatio * 100)}%` }"
      ></div>

      <div class="w-full flex justify-between absolute top-1/2 -translate-y-1/2 px-1">
        <div class="w-3 h-3 rounded-full bg-[#1c4848] ring-4 ring-white"></div>
        <div class="w-3 h-3 rounded-full bg-[#1c4848] ring-4 ring-white"></div>
        <div class="w-3 h-3 rounded-full bg-[#1c4848] ring-4 ring-white"></div>
        <div
          class="w-5 h-5 rounded-full bg-white border-4 border-[#ecd79f] shadow-[0_0_15px_rgba(236,215,159,0.5)] flex items-center justify-center animate-pulse-ring"
        ></div>
        <div class="w-3 h-3 rounded-full bg-white border-2 border-[#1c4848]/20"></div>
      </div>
    </div>

    <div
      class="flex items-center justify-between text-xs font-semibold text-[#1c4848]/40 border-t border-[#1c4848]/5 pt-3"
    >
      <span class="flex items-center gap-1">
        <iconify-icon icon="solar:map-point-linear"></iconify-icon>
        {{ locationLabel }}
      </span>
      <span class="flex items-center gap-1">
        <iconify-icon icon="solar:calculator-linear"></iconify-icon>
        {{ methodLabel }}
      </span>
      <span class="flex items-center gap-1" :class="alertsEnabled ? 'text-emerald-600' : ''">
        <iconify-icon icon="solar:bell-bing-linear"></iconify-icon>
        {{ alertsEnabled ? t('home.nextPrayer.meta.alertsOn') : t('home.nextPrayer.meta.alertsOff') }}
      </span>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import { usePrayerTimes } from '@/composables/usePrayerTimes';

const { t } = useI18n();
const { nextPrayer, countdownText, progressRatio, locationLabel, methodLabel, alertsEnabled } =
  usePrayerTimes();

function prayerLabel(key) {
  if (!key) return '';
  return t(`home.header.prayers.${key}`);
}
</script>

